export default {
  namespaced: true,

  getters: {
    some(state, getters, rootState, rootGetters) {
      const config = rootGetters['builder/config'];
      return (
        config.properties &&
        Object.keys(config.properties).length
      );
    },

    keys(state, getters, rootState, rootGetters) {
      if (!getters.some) {
        return [];
      }

      const config = rootGetters['builder/config'];
      return Object.keys(config.properties);
    },

    property(state, getters, rootState, rootGetters) {
      return (key) => {
        if (!getters.some) {
          throw new Error(`Invalid property ${key}`);
        }

        const property =
          rootGetters['builder/config'].properties[key];

        if (!property) {
          throw new Error(`Invalid property ${key}`);
        }

        return property;
      };
    },

    enabled(state, getters, rootState, rootGetters) {
      return (properties, key) => {
        if (!key) {
          return getters.some;
        }

        const property = getters.property(key);

        return rootGetters['builder/matcher/matches'](
          property.condition,
          properties,
        );
      };
    },

    required(state, getters) {
      return (key) => {
        const property = getters.property(key);
        return !!property.required;
      };
    },

    input(state, getters) {
      return (key) => {
        const { input } = getters.property(key);

        if (!input) {
          return 'text';
        }

        return input.toLowerCase();
      };
    },

    label(state, getters) {
      return (key) => {
        const property = getters.property(key);
        return property.label;
      };
    },

    htmlField(state, getters) {
      return (key) => {
        const input = getters.input(key);

        if (!input) {
          return 'text';
        }

        if (
          [
            'select',
            'entity',
            'field',
            'field_to_display',
          ].includes(input)
        ) {
          return 'select';
        }

        return input;
      };
    },

    help(state, getters) {
      return (key) => {
        const property = getters.property(key);

        if (!property.help) {
          return null;
        }

        return property.help;
      };
    },

    defaults(state, getters) {
      const { keys } = getters;

      if (!keys.length) {
        return {};
      }

      const defaults = {};

      keys.forEach((key) => {
        const defaultValue = getters.defaultValue(key);

        if (!defaultValue && defaultValue !== false) {
          return;
        }

        defaults[key] = defaultValue;
      });

      return defaults;
    },

    defaultValue(state, getters) {
      return (key) => {
        const property = getters.property(key);
        return property.default;
      };
    },

    choices(state, getters) {
      return (entities, key) => {
        const input = getters.input(key);

        if (input === 'entity') {
          return getters.entityChoices(entities);
        }

        return getters.propertyChoices(key);
      };
    },

    entityChoices() {
      return (entities) => {
        if (!entities || !entities.length) {
          return [];
        }

        return entities.map((entity) => ({
          value: entity.id,
          label: entity.name.singular,
        }));
      };
    },

    propertyChoices(state, getters) {
      return (key) => {
        const { choices } = getters.property(key);

        if (!choices || !Object.keys(choices).length) {
          return [];
        }

        return Object.keys(choices).map((choiceKey) => ({
          value: choiceKey,
          label: choices[choiceKey].label,
        }));
      };
    },
  },
};
